import { render, staticRenderFns } from "./StatementOfCosts.vue?vue&type=template&id=a1b9fe16&scoped=true&"
import script from "./StatementOfCosts.vue?vue&type=script&lang=js&"
export * from "./StatementOfCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b9fe16",
  null
  
)

export default component.exports